"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtUndo = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtUndo = function SvgBtUndo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.9381 7C11.5272 7 8.72569 9.35264 8.04066 12.5416L6.96829 10.7327C6.76653 10.4301 6.46384 10.4301 6.26209 10.531C5.95946 10.7327 5.95946 11.0354 6.06033 11.2372L7.97712 14.3646C8.07799 14.4655 8.17887 14.5664 8.27975 14.5664H8.38062C8.4815 14.5664 8.58238 14.5664 8.68326 14.6673L11.8107 12.7505C12.1133 12.5487 12.1133 12.246 12.0124 12.0443C11.8107 11.7416 11.508 11.7416 11.3062 11.8425L8.94757 13.2398C9.3531 10.297 11.8873 8.00895 14.9381 8.00895C18.2672 8.00895 20.9911 10.7328 20.9911 14.062C20.9911 17.3912 18.2672 20.115 14.9381 20.115C14.6354 20.115 14.4336 20.3167 14.4336 20.6194C14.4336 20.9221 14.6354 21.1239 14.9381 21.1239C18.8726 21.1239 21.9999 17.9964 21.9999 14.062C22 10.1274 18.8726 7 14.9381 7Z",
    fill: "currentColor"
  }));
};

exports.SvgBtUndo = SvgBtUndo;